// 자기 참조 방지 및 부모 추론
export const preprocessData = (data) => {
  return data.map(item => {
    if (item.MENU_ID === item.HIPO_MENU_ID) {
      const fallbackParent = data.find(
        cand => cand.MODULE_CD === item.MODULE_CD &&
                cand.MENU_LVL === item.MENU_LVL - 1
      );
      return {
        ...item,
        HIPO_MENU_ID: fallbackParent?.MENU_ID || null,
      };
    }
    return item;
  });
};
